/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES Proofreading API
 * PR TIMES 校正 API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    BadRequestError,
    BadRequestErrorFromJSON,
    BadRequestErrorToJSON,
    InternalServerError,
    InternalServerErrorFromJSON,
    InternalServerErrorToJSON,
    NotFoundError,
    NotFoundErrorFromJSON,
    NotFoundErrorToJSON,
    ProofreadingGetLintResultsResponse,
    ProofreadingGetLintResultsResponseFromJSON,
    ProofreadingGetLintResultsResponseToJSON,
    ProofreadingLintResponse,
    ProofreadingLintResponseFromJSON,
    ProofreadingLintResponseToJSON,
    ProofreadingMainResponse,
    ProofreadingMainResponseFromJSON,
    ProofreadingMainResponseToJSON,
    ProofreadingRequestBody,
    ProofreadingRequestBodyFromJSON,
    ProofreadingRequestBodyToJSON,
    UnauthorizedError,
    UnauthorizedErrorFromJSON,
    UnauthorizedErrorToJSON,
} from '../models';

export interface ProofreadingGetLintResultsRequest {
    lintId: string;
    xPrtAuthorization?: string;
}

export interface ProofreadingLintRequest {
    xPrtAuthorization?: string;
    proofreadingRequestBody?: ProofreadingRequestBody;
}

export interface ProofreadingMainRequest {
    xPrtAuthorization?: string;
    proofreadingRequestBody?: ProofreadingRequestBody;
}

/**
 * 
 */
export class ProofreadingApi extends runtime.BaseAPI {

    /**
     * ShodoAPIによる校正の結果を取得する
     * ProofreadingGetLintResults
     */
    async proofreadingGetLintResultsRaw(requestParameters: ProofreadingGetLintResultsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ProofreadingGetLintResultsResponse>> {
        if (requestParameters.lintId === null || requestParameters.lintId === undefined) {
            throw new runtime.RequiredError('lintId','Required parameter requestParameters.lintId was null or undefined when calling proofreadingGetLintResults.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xPrtAuthorization !== undefined && requestParameters.xPrtAuthorization !== null) {
            headerParameters['x-prt-authorization'] = String(requestParameters.xPrtAuthorization);
        }

        const response = await this.request({
            path: `/lint/{lint_id}`.replace(`{${"lint_id"}}`, encodeURIComponent(String(requestParameters.lintId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProofreadingGetLintResultsResponseFromJSON(jsonValue));
    }

    /**
     * ShodoAPIによる校正の結果を取得する
     * ProofreadingGetLintResults
     */
    async proofreadingGetLintResults(requestParameters: ProofreadingGetLintResultsRequest, initOverrides?: RequestInit): Promise<ProofreadingGetLintResultsResponse> {
        const response = await this.proofreadingGetLintResultsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ShodoAPIによる校正
     * ProofreadingLint
     */
    async proofreadingLintRaw(requestParameters: ProofreadingLintRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ProofreadingLintResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xPrtAuthorization !== undefined && requestParameters.xPrtAuthorization !== null) {
            headerParameters['x-prt-authorization'] = String(requestParameters.xPrtAuthorization);
        }

        const response = await this.request({
            path: `/lint`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ProofreadingRequestBodyToJSON(requestParameters.proofreadingRequestBody),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProofreadingLintResponseFromJSON(jsonValue));
    }

    /**
     * ShodoAPIによる校正
     * ProofreadingLint
     */
    async proofreadingLint(requestParameters: ProofreadingLintRequest = {}, initOverrides?: RequestInit): Promise<ProofreadingLintResponse> {
        const response = await this.proofreadingLintRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * メイン校正機能(リリース削除対象単語、4byte文字、リンク切れ)
     * ProofreadingMain
     */
    async proofreadingMainRaw(requestParameters: ProofreadingMainRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ProofreadingMainResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xPrtAuthorization !== undefined && requestParameters.xPrtAuthorization !== null) {
            headerParameters['x-prt-authorization'] = String(requestParameters.xPrtAuthorization);
        }

        const response = await this.request({
            path: `/main`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ProofreadingRequestBodyToJSON(requestParameters.proofreadingRequestBody),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProofreadingMainResponseFromJSON(jsonValue));
    }

    /**
     * メイン校正機能(リリース削除対象単語、4byte文字、リンク切れ)
     * ProofreadingMain
     */
    async proofreadingMain(requestParameters: ProofreadingMainRequest = {}, initOverrides?: RequestInit): Promise<ProofreadingMainResponse> {
        const response = await this.proofreadingMainRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
